<template>
  <v-card>
    <v-card-title>404</v-card-title>
    <v-card-subtitle>Page not allowed or not found</v-card-subtitle>
  </v-card>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped></style>
